var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{staticClass:"pb-2 mt-1",attrs:{"items":_vm.tenants,"label":_vm.$t('Tenant'),"dense":"","item-text":"name","item-value":"id","hide-details":"","outlined":""},on:{"change":_vm.loginAsTenant},model:{value:(_vm.tenant),callback:function ($$v) {_vm.tenant=$$v},expression:"tenant"}})
}
var staticRenderFns = []

export { render, staticRenderFns }